<div class="content-container">
    <div><img src="assets/images/logo.png" alt="Site Logo"/></div>
    <div class="description-container">
        <div><img class="error-image" src="assets/images/500.svg" alt="Error"/></div>
        <div class="text-container"><h3>Something went wrong...</h3><p>We are working on fixing the problem. Please try again</p></div>
        <div><button mat-flat-button color="primary"><mat-icon svgIcon="pq:rotate_refresh_loading_2"></mat-icon>Refresh page</button></div>
    </div>
</div>
<app-footer></app-footer>